import { EditLayoutErrorBoundary } from "src/framework/edit/EditLayoutErrorBoundary.tsx";
import { EditLayoutV2 } from "src/framework/editV2/EditLayoutV2.tsx";
import { queryClient } from "src/lib/react-query.tsx";
import { resourceFormConfigQuery } from "src/system/resourceFormConfigQuery.ts";

import { formTranslationsQuery } from "src/system/formTranslationsQuery.ts";
import { FormAction } from "src/components/Form/Form.types.ts";

export type CreateEditLayoutV2Props = {
  resource: string;
  layoutForm?: boolean;
};

export function createEditLayoutV2({
  resource,
  layoutForm,
}: CreateEditLayoutV2Props) {
  const Component = () => {
    return <EditLayoutV2 layoutForm={layoutForm} resource={resource} />;
  };

  const loader = async () => {
    if (layoutForm) {
      await Promise.all([
        queryClient.ensureQueryData(
          resourceFormConfigQuery({
            resource: resource,
            action: FormAction.Edit,
          }),
        ),
        queryClient.ensureQueryData(
          formTranslationsQuery({
            resource,
            action: FormAction.Edit,
          }),
        ),
      ]);
    }

    return null;
  };

  const ErrorBoundary = EditLayoutErrorBoundary;

  return {
    Component,
    ErrorBoundary,
    loader,
  };
}
